/*
 * <slideshow-element> touch swipe + desktop mouse drag. Slide image links (.hp-slidershow__media-link)
 * must still allow swipe/drag without opening the URL (click only when the pointer did not drag).
 */
(() => {
  if (window.hpEnableSlideshowMouseDrag) return;

  const THRESHOLD = 40;
  const DRAG_HINT = 6;
  // pointerup (bu script) ve touchend (slideshow'un kendi swipe'ı) aynı harekette
  // art arda goNext/goPrev çağırıyor; tek kaydırmada birden fazla slayt atlanmasın.
  const SWIPE_LOCK_MS = 200;

  const guardSwipe = (slideshow) => {
    if (slideshow.__hpSwipeGuarded) return;
    slideshow.__hpSwipeGuarded = true;

    const wrap = (method) => {
      const original = slideshow[method];
      if (typeof original !== 'function') return;
      slideshow[method] = function hpGuardedSwipe(...args) {
        const now = performance.now();
        if (now < (slideshow.__hpSwipeLockUntil || 0)) return;
        slideshow.__hpSwipeLockUntil = now + SWIPE_LOCK_MS;
        return original.apply(this, args);
      };
    };

    wrap('goNext');
    wrap('goPrev');
  };

  window.hpEnableSlideshowMouseDrag = (slideshow, options = {}) => {
    if (!slideshow || slideshow.dataset.hpMouseDragBound === 'true') return;
    slideshow.dataset.hpMouseDragBound = 'true';
    guardSwipe(slideshow);

    const ignore =
      options.ignore ||
      'button, input, select, textarea, [data-no-drag], .hp-slidershow__button';

    const slideCount = () => slideshow.querySelectorAll(':scope > .slideshow__slide').length;

    const bindDragSurface = (surface, { stopPropagationOnStart = false } = {}) => {
      let startX = 0;
      let startY = 0;
      let tracking = false;
      let dragged = false;
      let suppressClick = false;

      surface.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (slideCount() < 2) return;
        if (surface === slideshow && event.target.closest(ignore)) return;
        if (surface === slideshow && event.target.closest('.hp-slidershow__media-link')) return;

        tracking = true;
        dragged = false;
        suppressClick = false;
        startX = event.clientX;
        startY = event.clientY;

        if (stopPropagationOnStart) {
          event.stopPropagation();
        }

        if (surface.setPointerCapture && event.pointerId != null) {
          try {
            surface.setPointerCapture(event.pointerId);
          } catch {
            /* ignore */
          }
        }
      });

      surface.addEventListener('pointermove', (event) => {
        if (!tracking) return;
        if (Math.abs(event.clientX - startX) > DRAG_HINT) {
          dragged = true;
          slideshow.classList.add('is-mouse-dragging');
        }
      });

      const finish = (event) => {
        if (!tracking) return;
        tracking = false;
        slideshow.classList.remove('is-mouse-dragging');

        if (surface.releasePointerCapture && event.pointerId != null) {
          try {
            surface.releasePointerCapture(event.pointerId);
          } catch {
            /* ignore */
          }
        }

        const dx = event.clientX - startX;
        const dy = event.clientY - startY;

        if (Math.abs(dx) < THRESHOLD || Math.abs(dx) < Math.abs(dy) * 1.5) {
          dragged = false;
          suppressClick = false;
          return;
        }

        suppressClick = true;
        dragged = true;

        if (dx < 0) {
          slideshow.goNext?.();
        } else {
          slideshow.goPrev?.();
        }
      };

      surface.addEventListener('pointerup', finish);
      surface.addEventListener('pointercancel', () => {
        tracking = false;
        dragged = false;
        suppressClick = false;
        slideshow.classList.remove('is-mouse-dragging');
      });
      surface.addEventListener('pointerleave', (event) => {
        if (surface.hasPointerCapture?.(event.pointerId)) return;
        finish(event);
      });

      surface.addEventListener(
        'click',
        (event) => {
          if (!suppressClick && !dragged) return;
          suppressClick = false;
          dragged = false;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    };

    bindDragSurface(slideshow);

    slideshow.querySelectorAll('.hp-slidershow__media-link').forEach((link) => {
      bindDragSurface(link, { stopPropagationOnStart: true });
    });

    slideshow.addEventListener('dragstart', (event) => {
      if (event.target.closest('img, a, picture')) event.preventDefault();
    });
  };
})();
